import React, { useState, useEffect } from 'react';
import './StartGame.css';
import GameContentProvider from '../providers/GameContentProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loadGuestToken } from '../auth/authSlice';
import { useTranslation } from 'react-i18next';



const StartGame = () => {
    const { t, i18n } = useTranslation();

    const [inputValue, setInputValue] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [gameCompleted, setGameCompleted] = useState(false);
    const [invalidCoupon, setInvalidCoupon] = useState(false);
    const [timeout, setTimeout] = useState(false);




    const dispatch = useDispatch();

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const { coupon } = location.state || {};

        if (coupon) {
            setInputValue(coupon);
        }
        
    }, [location.state]);


    const handleStartGameClick = async () => {
        console.log('Starting the game with input:', inputValue);
        if (inputValue == "") {
            setInvalidCoupon(true);
            return;
        }

        const gameContentProvider = new GameContentProvider();

        let token;
        token = localStorage.getItem('token');
        if (!token) {

            token = localStorage.getItem('guest_token');
            if (!token) {
                const newToken = await gameContentProvider.registerGuest();
                localStorage.setItem('guest_token', newToken.token);
                dispatch(loadGuestToken());
                token = newToken.token;
            }
        }
        const [couponData, status] = await gameContentProvider.checkCoupon(inputValue, token, i18n.language);
        // console.log(status);
        if (status == 429) {
            //Too many wrong reqeusts. Wait 1 min
            setTimeout(true);
            return;
        }

        console.log(couponData);

        if (couponData) {
            console.log("1");
            if (couponData.used === 1) {
                console.log("1 1");
                let data;
                let otherComponentURL;

                const endTime = new Date(couponData.end_date);
                const startTime = new Date(couponData.start_date);

                // Get the current datetime
                const currentTime = new Date();

                console.log(currentTime);
                console.log(startTime);
                console.log(endTime);

                if (couponData.type === 2) {
                    console.log("1 1 1");
                    data = {
                        game: couponData.game_id,
                        coupon: inputValue,
                        step: couponData.last_step,
                        type: couponData.type,
                        duration: couponData.duration,
                        number_of_steps: couponData.number_of_steps,
                        team_game_id: couponData.team_game_id,
                    };

                    const currentUtcDate = new Date(currentTime.getTime() + (currentTime.getTimezoneOffset() * 60000)); // Convert current date to UTC

                    if (currentUtcDate < startTime) {
                        console.log("1 1 1 1");
                        //Game has not started. Go in teams register room
                        data = {
                            game_id: couponData.game_id,
                            code: couponData.code,
                            start_date: couponData.start_date,
                            team_game_id: couponData.team_game_id,
                        };

                        navigate('/waiting_screen', { state: data });
                        return;

                    } else if (currentUtcDate < endTime) {
                        console.log("1 1 1 2");
                        //Game has already started
                        otherComponentURL = '/game-team-steps/';

                        const gameStepsWindow = window.open(otherComponentURL, '_blank');
                        gameStepsWindow.addEventListener('load', () => {
                            gameStepsWindow.postMessage(data, window.origin);
                        });

                    } else {
                        //Game is completed
                        console.log("1 1 1 3");
                        setGameCompleted(true);
                    }


                } else {
                    console.log("1 1 2");



                    if (couponData.completed === 1 || (currentTime > endTime)) {
                        console.log("1 1 2 1");
                        setGameCompleted(true);
                    } else {
                        console.log("1 1 2 2");
                        data = {
                            game: couponData.game_id,
                            step: couponData.last_step,
                            type: couponData.type,
                            play_id: couponData.play_id,
                            duration: couponData.duration,
                            number_of_steps: couponData.number_of_steps,
                        };
                        otherComponentURL = '/game-steps/';

                        const gameStepsWindow = window.open(otherComponentURL, '_blank');
                        gameStepsWindow.addEventListener('load', () => {
                            gameStepsWindow.postMessage(data, window.origin);
                        });
                    }
                }
            } else if(new Date(couponData.expiration_date) < new Date()){
                setInvalidCoupon(true);
            }else {
                console.log("1 2");
                const warningScreenURL = '/warningscreen';
                const data = {
                    game: couponData.game_id,
                    coupon: inputValue,
                    type: couponData.type,
                    duration: couponData.duration,
                    number_of_steps: couponData.number_of_steps,
                    start_location: couponData.start_location,
                };
                console.log(data);
                navigate(warningScreenURL, { state: data });
            }
        } else {
            console.log("2");
            setInvalidCoupon(true);
        }

    };

    const closeModal = () => {
        setShowModal(false);
        setInvalidCoupon(false);
        setTimeout(false);
    };

    return (
        <div className="start-game">
            <div className='background-image-start-game'>
            <div className="center-container-start-game">
                <h2>{t("start_the_game")}</h2>
                <h3>{t('start_game_explanation')}</h3>
                <input
                    type="text"
                    placeholder={t("enter_coupon")}
                    value={inputValue}
                    onChange={handleInputChange}
                />
                <button onClick={handleStartGameClick}>{t("start")}</button>
                {/* Invalid coupon overlay */}

                
            </div>

            {invalidCoupon && (
                    <div className="overlay">
                        <div className="overlay-content">
                            <h2>{t("invalid_coupon")}</h2>
                            <p>{t("please_try_again")}</p>
                            <button onClick={closeModal}>{t("close")}</button>
                        </div>
                    </div>
                )}
                {/* Too many wrong reqeusts */}
                {timeout && (
                    <div className="overlay">
                        <div className="overlay-content">
                            <h2>{t("too_many_wrong_requests")}</h2>
                            <p>{t("please_try_again_in_1_minute")}</p>
                            <button onClick={closeModal}>{t("close")}</button>
                        </div>
                    </div>
                )}

                {/* Game completed overlay */}
                {gameCompleted && (
                    <div className="overlay">
                        <div className="overlay-content">
                            <h2>{t("game_completed")}</h2>
                            <p>{t("this_game_has_been_completed")}</p>
                            <button onClick={() => setGameCompleted(false)}>{t("close")}</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StartGame;
